import { REDUCER } from '../reducers/reducersConst';

/**
 * THEME DATA REDUCER
 */
let defaultThemeState = {
  loaded: false,
  colors: {
    primary: '#ccc',
    backgroundPrimary: '#ccc',
    backgroundSecondary: '#ccc',
    btnDefault: '#ccc',
    btnDefaultHover: '#ccc',
    btnSuccess: '#ccc',
    btnSuccessHover: '#ccc',
    btnDanger: '#ccc',
    btnDangerHover: '#ccc',
    itemMenuHover: '#ccc',
    btnText: '#ccc',
    btnTextHover: '#ccc',
    alert: '#ccc',
    group01: '#ccc',
    group02: '#ccc',
    group03: '#ccc',
    group04: '#ccc',
    group05: '#ccc',
    group06: '#ccc',
    group07: '#ccc',
    group08: '#ccc',
    group09: '#ccc',
    group010: '#ccc',
    classroom01: '#ccc',
    classroom02: '#ccc',
    classroom03: '#ccc',
    classroom04: '#ccc',
    classroom05: '#ccc'
  },
  images: {
    logos: {
      small: undefined,
      big: undefined
    },
    headers: {
      book: undefined,
      menu: undefined
    },
    placeholders: {
      book: undefined,
      empty: undefined,
      emptyClassrooms: undefined
    },
    icons: {
      individual: undefined,
      everyone: undefined
    }
  }
};

/**
 * Theme Reducer for Custom Look and Feel
 * @param state
 * @param action
 * @returns {*}
 */
export let theme = (state = defaultThemeState, action) => {
  switch (action.type) {
    case REDUCER.THEME.SET_THEME:
      return {
        ...state,
        ...action.theme
      };
    case REDUCER.THEME.LOADED_THEME:
      return {
        ...state,
        loaded: action.loaded
      };
    case REDUCER.THEME.SKIN_URL:
      return {
        ...state,
        skinUrl: action.skinUrl
      };
    default:
      return state;
  }
};
